import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChatHeader = ({ 
  instituteName, 
  representativeName,
  isOnline, 
  onVideoCall, 
  onBack,
  instituteAvatar,
  instituteAvatarAlt,
  handlerType,
  onTakeover
}) => {
  return (
    <div className="sticky top-0 z-10 bg-card border-b border-border px-4 md:px-6 py-3 md:py-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <button
            onClick={onBack}
            className="lg:hidden p-2 -ml-2 hover:bg-muted rounded-lg transition-smooth"
            aria-label="Go back"
          >
            <Icon name="ArrowLeft" size={20} />
          </button>

          <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden flex-shrink-0 bg-primary/10">
            <img
              src={instituteAvatar}
              alt={instituteAvatarAlt}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.src = '/assets/images/no_image.png';
              }}
            />
          </div>

          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h2 className="text-base md:text-lg font-semibold text-foreground truncate">
                {instituteName}
              </h2>
              {handlerType === 'ai' && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-accent/10 text-accent">
                  <Icon name="Bot" size={12} />
                  AI
                </span>
              )}
              {handlerType === 'human' && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-success/10 text-success">
                  <Icon name="User" size={12} />
                  Human
                </span>
              )}
            </div>
            <div className="flex items-center gap-2 mt-0.5">
              <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-success' : 'bg-muted-foreground'}`} />
              <span className="text-xs md:text-sm text-muted-foreground">
                {isOnline ? `${representativeName} is online` : 'Offline'}
              </span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {handlerType === 'ai' && onTakeover && (
            <Button
              variant="default"
              size="sm"
              onClick={onTakeover}
              className="flex-shrink-0"
            >
              <Icon name="UserPlus" size={16} className="mr-1" />
              Take Over
            </Button>
          )}
          <Button
            variant="outline"
            size="icon"
            onClick={onVideoCall}
            disabled={!isOnline}
            className="flex-shrink-0"
          >
            <Icon name="Video" size={20} />
          </Button>

          <Button
            variant="ghost"
            size="icon"
            className="flex-shrink-0"
          >
            <Icon name="MoreVertical" size={20} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;